import * as preact from "preact";

import * as practiceUtils from "practiceUtils";
import UserWordStore from "stores/UserWordStore";

interface State {}

class DefaultChallengeView extends preact.Component<
  practiceUtils.ChallengeProps,
  State
> {
  userWords: UserWordStore[];

  render() {
    return <div>Challenge type not implemented</div>;
  }
}

export default DefaultChallengeView;
